// extracted by mini-css-extract-plugin
export var actionButton = "_nt-0";
export var actionMenuContainer = "_nt-i";
export var bubble = "_nt-2";
export var bubbleActionMenu = "_nt-j";
export var bubbleContext = "_nt-6";
export var bubbleItems = "_nt-7";
export var customer = "_nt-3";
export var divider = "_nt-8";
export var fileList = "_nt-9";
export var hiddenComment = "_nt-o";
export var infoAbove = "_nt-a";
export var internal = "_nt-4";
export var lightActionButton = "_nt-1";
export var link = "_nt-b";
export var merchant = "_nt-5";
export var message = "_nt-c";
export var profilePicture = "_nt-e";
export var quillToolbarContainer = "_nt-f";
export var senderDate = "_nt-g";
export var senderDateCustomer = "_nt-h";
export var senderName = "_nt-d";
export var time = "_nt-k";
export var uploadedImage = "_nt-l";
export var username = "_nt-m";
export var xsmall = "_nt-n";